// extracted by mini-css-extract-plugin
module.exports = {"table":"table__table___2QxnL","tableTitles":"table__tableTitles___35rTa","tableHeader":"table__tableHeader___3VsAm"};